import { useMutation } from 'react-query';
import {
  sendOfferMailBySessionId,
  SendOfferMailBySessionIdBody,
} from 'wg-api-sdk';
import { wgApiSdk } from '../../../../app/src/features/api/wgApi';

interface SendOfferEmailParams {
  sessionId: string;
  payload: SendOfferMailBySessionIdBody;
}

export const postAnvaSendOfferEmail = async ({
  sessionId,
  payload,
}: SendOfferEmailParams) => {
  return await sendOfferMailBySessionId(
    {
      body: payload,
      params: {
        path: {
          session_id: sessionId,
        },
        query: {},
      },
    },
    wgApiSdk,
  );
};

export const usePostAnvaSendOfferEmail = () => {
  return useMutation(postAnvaSendOfferEmail);
};


